import { render, staticRenderFns } from "./InsuranceReport.vue?vue&type=template&id=7f9b7274&lang=pug"
import script from "./InsuranceReport.vue?vue&type=script&lang=js"
export * from "./InsuranceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports